
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { GameData } from "../../server/data/BaseModel";
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';


export class NormalStoppedPresentation extends Presentation {

    private gameData: GameData;

    private delayALittleBit:boolean = false;

    setGamedData(data: GameData): void {
        this.gameData = data;
        this.delayALittleBit = this.gameData.isNormalMode && data.Reel.amountOfScatters >= 2;
    }

    preStart(): void {
    }

    checkForActivation(data:GameData){
        return true;
    }

    createPresentation(enableSkip: Function) {
        if(this.delayALittleBit){
            enableSkip(true);
            this.timeline.to(this,{duration:0.35});
        }
            
        this.PresentationState.setInactive();
    }

    done(): void {
    }
}